import { render, staticRenderFns } from "./photonPersistentDisk.vue?vue&type=template&id=2283ef51&"
import script from "./photonPersistentDisk.vue?vue&type=script&lang=js&"
export * from "./photonPersistentDisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports